/**
 * Hides a popover.
 *
 * @param elem The popover element.
 */
export function hidePopover(elem: HTMLDivElement): void {
	elem.classList.remove("rt-popover-open");
	document.body.classList.remove("rt-noscroll");
}

/** Initializes all popover toggles. */
export function init(): void {
	const toggles =
		document.querySelectorAll<HTMLDivElement>(".rt-popover-toggle");
	toggles.forEach((toggle) => {
		initToggle(toggle);
	});
}
/**
 * Shows a popover.
 *
 * @param elem The popover element.
 * @param customCloseCallback An optional callback to run when the popover is
 *   closed.
 */
export function showPopover(
	elem: HTMLDivElement,
	customCloseCallback?: () => void,
): void {
	elem.classList.add("rt-popover-open");
	document.body.classList.add("rt-noscroll");
	elem.addEventListener("click", () => {
		hidePopover(elem);
		if (customCloseCallback) customCloseCallback();
	});
	elem.childNodes.forEach((child) => {
		child.addEventListener("click", (e) => {
			hideCancelling(e);
		});
	});
}

/**
 * Prevents the popover from closing when clicking on certain elements.
 *
 * @param e The event to check.
 */
function hideCancelling(e: Event) {
	const target = e.target as HTMLElement;
	const { nodeName } = target;
	if (nodeName === "A" || nodeName === "IMG") return;
	e.stopPropagation();
}

/**
 * Initializes a popover toggle.
 *
 * @param toggle The toggle element.
 */
function initToggle(toggle: HTMLDivElement) {
	const id = toggle.dataset.target;
	if (!id) {
		console.error("No target found for popover toggle");
		return;
	}
	const popover = document.getElementById(id) as HTMLDivElement;
	if (!popover) {
		console.error(`No popover found with ID ${id}`);
		return;
	}
	toggle.addEventListener("click", () => {
		if (popover.classList.contains("rt-popover-open")) {
			hidePopover(popover);
		} else {
			showPopover(popover);
		}
	});
}
